import React from 'react';
import {Card} from "@mui/material";

const _UserPayTransactions = () => {
    return (
        <Card variant={"outlined"} sx={{m:1,p:1}}>
            به زودی
        </Card>
    );
};

export default _UserPayTransactions;
